import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ScrollToTop from "./components/ScrollToTop";
import ReleaseBanner from "./components/ReleaseBanner/ReleaseBanner";
import UserRoute from "./Routes/UserRoute";
import { fetchDepartments } from "./features/departments/departmentThunks";
import { fetchEmployees } from "./features/employees/employeeThunks";
import { fetchProjects } from "./features/projects/projectThunks";
import { fetchGroups } from "./features/groups/groupThunks";

const App = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const departments = useSelector((state) => state.departments.departments) || [];
  const employees = useSelector((state) => state.employees.employees) || [];
  const projects = useSelector((state) => state.projects.projects) || [];
  const groups = useSelector((state) => state.groups.groups) || [];

  useEffect(() => {
    if (isAuthenticated) {
      if (departments.length === 0) dispatch(fetchDepartments());
      if (employees.length === 0) dispatch(fetchEmployees());
      if (projects.length === 0) dispatch(fetchProjects());
      if (groups.length === 0) dispatch(fetchGroups());
    }
  }, [isAuthenticated, dispatch, departments.length, employees.length, projects.length, groups.length]);

  return (
    <>
      <ScrollToTop />
      <UserRoute />
      <ReleaseBanner />
    </>
  );
};

export default App;
